import { RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { getAuth, User } from "firebase/auth";

export function globalAuthGuard(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged((user: User | null) => {
        if (to.matched.some(record => record.meta.requiresAuth && record.meta.requiresAuth === true)) {
            if (user) {
                next();
            } else {
                next('/login');
            }
        } else {
            next();
        }
        unsubscribe();
    });
}